export default "__VITE_ASSET__DY73oRkp__"